import Box, { BoxProps } from '@mui/material/Box';
import { FormEvent, forwardRef } from 'react';
import { FormProvider, FormProviderProps } from 'react-hook-form';
import ComponentLoader from '../wrappers/ComponentLoader';

type IProps = React.PropsWithChildren<{
    methods: Omit<FormProviderProps, 'children'>;
    isLoaded?: boolean;
    name: string;
    readOnly?: boolean;
    onSubmit?: (e: FormEvent<HTMLFormElement>, buttonName: string) => void;
}> &
    Pick<BoxProps, 'sx'>;

const FormWrapper = forwardRef<HTMLFormElement, IProps>(function FormWrapperInner(
    { children, methods, name, onSubmit, readOnly, isLoaded = true, ...rest },
    ref
) {
    if (readOnly) {
        return (
            <FormProvider {...methods}>
                <Box {...rest} ref={ref} data-testid={`form-${name}`}>
                    <ComponentLoader inProgress={!isLoaded}>{children}</ComponentLoader>
                </Box>
            </FormProvider>
        );
    }

    return (
        <FormProvider {...methods}>
            <Box
                {...rest}
                ref={ref}
                component="form"
                onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                    e.preventDefault();

                    if (onSubmit) {
                        onSubmit(e, /*e.nativeEvent.submitter?.getAttribute('name') || */ '');
                    }
                }}
                sx={{
                    ...(rest.sx ?? {}),
                    position: 'relative'
                }}
                data-testid={`form-${name}`}
            >
                <ComponentLoader inProgress={!isLoaded}>{children}</ComponentLoader>
            </Box>
        </FormProvider>
    );
});

export default FormWrapper;
